import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=1315e208&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=1315e208&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports